// All the initial data needed to start to work with the this store

// Incentive store types
import { IncentiveStoreModel } from '../../typings/incentive-store';

/**
 * The initial data state for this store
 */
export function getInitialState(): IncentiveStoreModel {
  return {
    form: {
      selectedTab: "modelDetails",
    },
    currentData: {
      model: 'Model',
      modelYear: 'YYYY',
      trim: 'Trim',
      vin: undefined,
      carImage: undefined,
      modelYears: [],
      carlines: [],
      trims: []
    },
    status: 'pending',
    formValidationError: {
      model: false,
      modelYear: false,
      trim: false,
      mileage: false,
      vin: false,
    },
    modelYears: [],
    vehicle: {
      modelYear: '',
      model: '',
      trim: '',
      vin: '',
      modelCode: ''
    }
  };
}
